import { Injectable } from '@angular/core';

/**
 * Serviço que centraliza as regras de negócio de filtragem de produtos offline.
 * Suporta filtro por texto, mix, categoria, condição de armazenamento e origem.
 */
@Injectable({ providedIn: 'root' })
export class DefaultLocalProductService {
  /**
   * Filtra uma lista de produtos pela query no formato
   * `termo:faceta1:valor1:faceta2:valor2`.
   */
  filterProducts(products: any[], query: string): any[] {
    if (!query) {
      return products;
    }

    const parts = query.split(':');
    const term = parts[0]?.toLowerCase() ?? '';
    let filtered = products;

    if (term) {
      filtered = filtered.filter(
        product =>
          product.name?.toLowerCase().includes(term) ||
          product.code?.toLowerCase().includes(term) ||
          product.sapName?.toLowerCase().includes(term),
      );
    }

    for (let index = 2; index < parts.length - 1; index += 2) {
      const key = parts[index];
      const value = parts[index + 1];

      if (key === 'mixCodes') {
        const hasMixMetadata = filtered.some(product => Array.isArray(product.mixCodes ?? product.mixes));
        if (hasMixMetadata) {
          filtered = filtered.filter(product => this.matchesFacetValue(product.mixCodes ?? product.mixes, value));
        }
      } else if (key === 'categories') {
        filtered = filtered.filter(product => this.matchesFacetValue(product.categories, value));
      } else if (key === 'storageCondition') {
        filtered = filtered.filter(product => this.matchesScalarValue(product.storageCondition, value));
      } else if (key === 'origin') {
        filtered = filtered.filter(product => product.origin === value);
      }
    }

    return filtered;
  }

  private matchesFacetValue(source: unknown, expected: string): boolean {
    if (!Array.isArray(source)) return false;
    return source.some(item => this.matchesScalarValue(item, expected));
  }

  private matchesScalarValue(source: unknown, expected: string): boolean {
    if (typeof source === 'string') return source === expected;

    if (source && typeof source === 'object') {
      const candidate = source as { code?: string; description?: string; name?: string; value?: string };
      return [candidate.code, candidate.description, candidate.name, candidate.value].some(item => item === expected);
    }

    return false;
  }
}
